import type { Xinglet } from '@xing-com/crate-xinglet';

import { MasterDirectorySkillPage } from './skill';

export default class Skill implements Xinglet {
  public getComponent() {
    return () => <MasterDirectorySkillPage />;
  }
}
